<template>
  <div class="preloader">
    <div class="loader">
      <svg class="circular-loader" viewBox="25 25 50 50">
        <circle
          class="loader-path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke="#ffd100"
          stroke-width="4"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.preloader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .loader {
    position: relative;
    width: 5vw;
    width: 5vw;

    &:before {
      content: "";
      display: block;
      padding-top: 100%;
    }
  }

  .circular-loader {
    transform-origin: center center;
    animation: rotate 2s linear infinite;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
  }

  .loader-path {
    stroke-dasharray: 150, 200;
    stroke-dashoffset: -10;
    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
@keyframes color {
  0% {
    stroke: #ffd100;
  }
  40% {
    stroke: #ffd100;
  }
  66% {
    stroke: #e95526;
  }
  80%,
  90% {
    stroke: #ffd100;
  }
}
</style>
